import Flow from "./flow";
import capitalize from "../helpers/capitalize";

// Type for YAML-based flow types
export interface YamlFlowType {
  id: string;
  yamlId: string;
  slug: string;
  name: string;
  description?: string;
  flows?: any[];
}

export default class FlowType {
  id: string;
  yamlId: string;
  slug: string;
  name: string;
  label: string;
  description: string;
  flows: Flow[];

  constructor(type: YamlFlowType) {
    this.id = type.id;
    this.yamlId = type.yamlId;
    this.slug = type.slug!;
    this.name = type.name!;
    this.label = capitalize(type.name!);
    this.description = type.description || "";
    this.flows = type.flows
      ? type.flows.map((flow: any) => new Flow(flow))
      : [];
  }
}
